import React from "react";
import styled from 'styled-components';

/* Tarjeta «Operarios asignados» de la ficha del parte y de logística. La API solo
   manda la lista (assigned_operators) a quien tiene el rol Administración en el
   parte; para los demás llega null y no se pinta nada. */

const CardStyled = styled.div`
	.operator {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 6px 0;

		& + .operator {
			border-top: 1px solid #eee;
		}
	}

	.avatar {
		flex: 0 0 34px;
		width: 34px;
		height: 34px;
		border-radius: 50%;
		background: #eef2fb;
		color: var(--bs-primary);
		font-size: 12px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.name {
		font-weight: 700;
		line-height: 1.2;
	}

	.role {
		font-size: 13px;
		color: #6c757d;
	}

	.phone {
		margin-left: auto;
		font-size: 14px;
		white-space: nowrap;
	}
`;

function initials(name) {
	return (name || '?').trim().split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
}

export default function AssignedOperators(props) {
	const operators = props.operators;
	if ( !operators ) return null;

	return (
		<CardStyled className={props.className ?? ''}>
			<div className="card">
				<div className="card-body">
					<h4 className="m-0 mb-2 text-primary">Operarios asignados</h4>
					{ operators.length === 0 && <div className="text-muted">No hay operarios asignados</div> }
					{ operators.map((operator, idx) =>
						<div className="operator" key={idx}>
							<div className="avatar">{ initials(operator.name) }</div>
							<div>
								<div className="name">{ operator.name }</div>
								<div className="role">{ operator.role }</div>
							</div>
							{ operator.phone && <a className="phone" href={'tel:' + operator.phone}>{ operator.phone }</a> }
						</div>
					) }
				</div>
			</div>
		</CardStyled>
	);
}
